var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        {
          attrs: { "body-class": "pt-0" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("h2", { staticClass: "section-separator-title" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("filogix.submitToFilogix")) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "w-40 btn btn-primary btn-sm",
                          attrs: {
                            id: "filogix-button",
                            type: "button",
                            disabled: _vm.submissionInProgress,
                          },
                          on: { click: _vm.triggerFilogixSubmission },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("filogix.submitToFilogix")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm.loading
            ? _c("deals-loader")
            : _c(
                "b-row",
                [
                  _c("b-col", [
                    _vm.submissionInProgress
                      ? _c(
                          "div",
                          { staticClass: "py-5", attrs: { id: "preload" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row h-100 justify-content-center align-items-center",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-12 text-center" },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "ld ld-ring ld-spin-fast huge",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h6",
                                      {
                                        staticClass: "mt-3 font-weight-s-bold",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "filogix.submissionInProgress"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }